import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { MemberGroupProjects } from "@components/common/member/member-group-projects";
import { getGroupAccess } from "@components/common/member/member-access-utils";
import { ACTION_BTN_SIZE, ACTION_ICON_SIZE } from "@styles/common-styles";
import { ArrowDownIcon, Text, ChevronUpIcon, Tooltip } from "@flat-ui";
import { Box, Grid, Stack } from "@mui-wrapper";
import { useAppSelector } from "@store/store-helper";
import { currentUserSelector } from "@store/user/user-selector";
import { withEllipsis } from "@styles/common-styles";
import { UserMenuEvents, UserProfile } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";
import { Link } from "react-router-dom";
import { generateGroupDetailsRoute } from "@router/router-helper";
import { useCompanyId } from "@context-providers/company-id-provider";
/** Renders a table with the groups of a company member */
export function MemberGroupsTable(t0) {
  const $ = _c(14);
  const {
    groups,
    member
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [expandedGroups, setExpandedGroups] = useState(t1);
  const currentUser = useAppSelector(currentUserSelector);
  let t2;
  if ($[1] !== currentUser?.identity || $[2] !== expandedGroups || $[3] !== groups || $[4] !== member || $[5] !== trackEvent) {
    let t3;
    if ($[7] !== currentUser?.identity || $[8] !== expandedGroups || $[9] !== member || $[10] !== trackEvent) {
      t3 = group => <Box component="div" key={group.id}><MemberGroupRow group={group} member={member} expandedGroups={expandedGroups} setExpandedRows={groups_0 => {
          trackEvent({
            name: UserProfile.expandGroupProjects,
            props: {
              isCurrentUser: currentUser?.identity === member?.identity
            }
          });
          setExpandedGroups(groups_0);
        }} />{expandedGroups.includes(group.id) && <MemberGroupProjects group={group} member={member} />}</Box>;
      $[7] = currentUser?.identity;
      $[8] = expandedGroups;
      $[9] = member;
      $[10] = trackEvent;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t2 = groups.map(t3);
    $[1] = currentUser?.identity;
    $[2] = expandedGroups;
    $[3] = groups;
    $[4] = member;
    $[5] = trackEvent;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[12] !== t2) {
    t3 = <Box component="div">{t2}</Box>;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}
/** Padding on the side elements in the row for the member group */
const PADDING_SIDE = "12px";

/** Renders a single group row */
function MemberGroupRow(t0) {
  const $ = _c(47);
  const {
    group,
    member,
    expandedGroups,
    setExpandedRows
  } = t0;
  const companyId = useCompanyId();
  const isGroupExpanded = expandedGroups.includes(group.id);
  let t1;
  if ($[0] !== group.role) {
    t1 = getGroupAccess(group.role);
    $[0] = group.role;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const groupAccess = t1;
  const {
    trackEvent
  } = useTrackEvent();
  let t2;
  if ($[2] !== expandedGroups || $[3] !== group.id || $[4] !== setExpandedRows) {
    t2 = function handleExpandGroup(event) {
      event.preventDefault();
      const isCurrentlyExpanded = expandedGroups.includes(group.id);
      setExpandedRows(isCurrentlyExpanded ? [] : [group.id]);
    };
    $[2] = expandedGroups;
    $[3] = group.id;
    $[4] = setExpandedRows;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleExpandGroup = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "center",
      backgroundColor: "surfaces.secondary",
      mb: "8px",
      paddingY: "20px",
      "&:hover": {
        backgroundColor: "surfaces.tertiary",
        cursor: "pointer"
      }
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      xs: 6
    };
    t5 = {
      ...withEllipsis,
      paddingX: PADDING_SIDE
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== companyId || $[10] !== group.id) {
    t6 = generateGroupDetailsRoute(companyId, group.id);
    $[9] = companyId;
    $[10] = group.id;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      textDecoration: "none"
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== group.id || $[14] !== member.kind || $[15] !== trackEvent) {
    t8 = e => {
      e.stopPropagation();
      trackEvent({
        name: UserMenuEvents.openGroupDetails,
        props: {
          origin: "Profile overview",
          kind: member.kind ?? "unknown",
          groupId: group.id
        }
      });
    };
    $[13] = group.id;
    $[14] = member.kind;
    $[15] = trackEvent;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      "&:hover": {
        textDecoration: "underline"
      }
    };
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== group.name) {
    t10 = <Text variant="bodyM" component="var" sx={t9}>{group.name}</Text>;
    $[18] = group.name;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t6 || $[22] !== t8) {
    t11 = <Grid size={t4} sx={t5}><Link to={t6} style={t7} onClick={t8}>{t10}</Link></Grid>;
    $[20] = t10;
    $[21] = t6;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      xs: 5
    };
    t13 = {
      paddingRight: PADDING_SIDE
    };
    $[24] = t12;
    $[25] = t13;
  } else {
    t12 = $[24];
    t13 = $[25];
  }
  let t14;
  if ($[26] !== groupAccess.label) {
    t14 = <Text variant="bodyM">{groupAccess.label}</Text>;
    $[26] = groupAccess.label;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      color: "text.secondary"
    };
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== groupAccess.description) {
    t16 = <Text variant="bodyS" sx={t15}>{groupAccess.description}</Text>;
    $[29] = groupAccess.description;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t14 || $[32] !== t16) {
    t17 = <Grid size={t12} sx={t13}><Stack>{t14}{t16}</Stack></Grid>;
    $[31] = t14;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  let t19;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      xs: 1
    };
    t19 = {
      paddingRight: PADDING_SIDE,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center"
    };
    $[34] = t18;
    $[35] = t19;
  } else {
    t18 = $[34];
    t19 = $[35];
  }
  const t20 = isGroupExpanded ? "Hide group projects" : "Show group projects";
  const t21 = isGroupExpanded ? ChevronUpIcon : ArrowDownIcon;
  let t22;
  if ($[36] !== handleExpandGroup || $[37] !== t21) {
    t22 = <SphereIconButton buttonSize={ACTION_BTN_SIZE} iconSize={ACTION_ICON_SIZE} component={t21} onClick={handleExpandGroup} />;
    $[36] = handleExpandGroup;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t20 || $[40] !== t22) {
    t23 = <Grid size={t18} sx={t19}><Tooltip component="div" title={t20}>{t22}</Tooltip></Grid>;
    $[39] = t20;
    $[40] = t22;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== handleExpandGroup || $[43] !== t11 || $[44] !== t17 || $[45] !== t23) {
    t24 = <Grid container={true} sx={t3} onClick={handleExpandGroup}>{t11}{t17}{t23}</Grid>;
    $[42] = handleExpandGroup;
    $[43] = t11;
    $[44] = t17;
    $[45] = t23;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  return t24;
}